/* eslint-disable no-console */
/* eslint-disable func-names */
import { all, spawn, call } from 'redux-saga/effects';
import i18n from 'react/api/sagas/i18n.js';
import auth from 'react/api/sagas/auth.js';
import passwordPolicies from 'react/api/sagas/passwordPolicies.js';
import { changePassword } from 'react/api/sagas/recoverPassword.js';
import tabs from 'react/api/sagas/tabs';
import crud from 'react/api/sagas/crud.js';
import routeMonitor, {
  paginateRouteMonitor
} from 'react/api/sagas/routeMonitor.js';
import pendingOrders, {
  pendingOrdersAggregate,
  updatePendingOrdersRow
} from 'react/api/sagas/pendingOrders.js';
import eventNotification from 'react/api/sagas/eventNotification.js';
import resequenceHistory from 'react/api/sagas/resequenceHistory.js';
import stopDetailsPopup from 'react/api/sagas/stopDetailsPopup.js';
import dashboardAnalytics from 'react/api/sagas/dashboardAnalytics.js';
import taskScheduler from 'react/api/sagas/taskScheduler.js';
import routeSurveyModal from 'react/api/sagas/routeSurveyModal';
import photoGallery from 'react/api/sagas/photoGallery';
import ticketHub from 'react/api/sagas/ticketHub';
import ticketDetails from 'react/api/sagas/ticketDetails';
import chat from 'react/api/sagas/chat';
import chatTicketActions from 'react/api/sagas/chatTicketActions';
import logoffAlertModal from 'react/api/sagas/logoffAlertModal';
import samlConfiguration from 'react/api/sagas/samlConfiguration';
import integrations from 'react/api/sagas/integrations';
import routeDivision from 'react/api/sagas/routeDivision';
import wglnIntegrationLogs from 'react/api/sagas/wglnIntegrationLogs';
import eventHttpActionLogs from 'react/api/sagas/eventHttpActionLogs';
import localzIntegration from 'react/api/sagas/localzIntegration';
import localzIntegrationLogs from 'react/api/sagas/localzIntegrationLogs';
import photoAlbum from 'react/api/sagas/photoAlbum';
import sku from 'react/api/sagas/sku';
import routeSummary from 'react/api/sagas/routeSummary';
import telematics from 'react/api/sagas/telematics';

export default function* rootSaga() {
  const sagas = [
    i18n,
    auth,
    passwordPolicies,
    changePassword,
    tabs,
    crud,
    routeMonitor,
    paginateRouteMonitor,
    pendingOrders,
    pendingOrdersAggregate,
    updatePendingOrdersRow,
    eventNotification,
    resequenceHistory,
    stopDetailsPopup,
    dashboardAnalytics,
    taskScheduler,
    routeSurveyModal,
    photoGallery,
    ticketHub,
    ticketDetails,
    chat,
    samlConfiguration,
    chatTicketActions,
    logoffAlertModal,
    integrations,
    routeDivision,
    wglnIntegrationLogs,
    eventHttpActionLogs,
    localzIntegration,
    localzIntegrationLogs,
    sku,
    photoAlbum,
    routeSummary,
    telematics
  ];

  yield all(
    sagas.map((saga) =>
      spawn(function* () {
        while (true) {
          try {
            yield call(saga);
            break;
          } catch (e) {
            console.error(e);
          }
        }
      })
    )
  );
}
